export const ATTACHMENT_SIZE_LIMIT = 10485760 // 10MB
export const ERROR_MESSAGE_TIMEOUT = 5000 // 5 seconds
export const MAX_ATTACHMENTS = 5 // 5 files
export const MAX_TEXT_LENGTH = 1000 // 1000 symbols
